import { Helmet } from 'react-helmet-async';

import { AmplifyTOTPCodeView } from 'src/sections/auth/amplify';


// ----------------------------------------------------------------------

export default function TOTPCode() {
  return (
    <>
      <Helmet>
        <title>HeyJob - Login</title>
      </Helmet>

      <AmplifyTOTPCodeView />
    </>
  );
}
